import { render } from "./add_claim_form.vue?vue&type=template&id=09603a60"
import script from "./add_claim_form.vue?vue&type=script&lang=js"
export * from "./add_claim_form.vue?vue&type=script&lang=js"

import "./add_claim_form.vue?vue&type=style&index=0&id=09603a60&lang=css"

import exportComponent from "/var/www/kutchinaasp-uat.kutchina.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__